module.exports = __webpack_public_path__ + "xero_logo.6fabb8e0c9510fdd0c6e445f89a7a972.png";